import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    defaultFolderName: string;
    errorMessage: string;
    loading: string;
    successMessage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Default name given to a newly created folder */
            defaultFolderName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateFolder.defaultFolderName?c=2x432uzeydtjf", defaultMessage: "untitled folder" }));
                },
                enumerable: true,
                configurable: true
            },
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateFolder.errorMessage?c=5w74x7pl7ypt", defaultMessage: "Failed to create folder." }));
                },
                enumerable: true,
                configurable: true
            },
            loading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateFolder.loading?c=3clcbmaxtgukm", defaultMessage: "Creating folder\u2026" }));
                },
                enumerable: true,
                configurable: true
            },
            successMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateFolder.successMessage?c=28hfjsij7oe2k", defaultMessage: "Folder created successfully." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
